<template>
  <div>
    <el-row class="bg-color-w py-20 px-30">
      <el-row class="">
        <div class="float-l"></div>
        <!-- 内容筛选： -->
        <span>{{$t('sqsq.nrsx')}}：</span>
        <el-button-group>
          <el-button
            size="small"
            :class="{ btnColor: btncolor == 3 }"
            type="primary"
            plain
            icon="el-icon-document"
            @click="filterSqzt(3)"
            >{{$t('common.all')}}</el-button
          >
          <el-button
            size="small"
            :class="{ btnColor: btncolor == 2 }"
            type="primary"
            plain
            icon="el-icon-edit"
            @click="filterSqzt(2)"
            >{{$t('sqsq.examine')}}</el-button
          >
          <el-button
            size="small"
            :class="{ btnColor: btncolor == 0 }"
            type="primary"
            plain
            icon="el-icon-check"
            @click="filterSqzt(0)"
            >{{$t('sqsq.adopt')}}</el-button
          >
          <el-button
            size="small"
            :class="{ btnColor: btncolor == 1 }"
            type="primary"
            plain
            icon="el-icon-close"
            @click="filterSqzt(1)"
            >{{$t('sqsq.reject')}}</el-button
          >
        </el-button-group>
        <!-- 设置显示字段 -->
        <el-dropdown
          trigger="click"
          class="float-r"
          v-if="xszdBtn && xszdBtn.isShow == '1'"
          :size="xszdBtn ? xszdBtn.componentSize : ''"
        >
          <el-button
            type="primary"
            :size="xszdBtn ? xszdBtn.componentSize : ''"
          >
            {{ xszdBtn ? xszdBtn.componentTiltle[$i18n.locale] : "" }}
          </el-button>
          <template #dropdown>
            <el-dropdown-menu>
              <template v-for="(item, index) in tableColumns">
                <el-dropdown-item :key="index" v-if="item.columnKey != 'xzk'">
                  <el-checkbox
                    v-model="show[index]"
                    :label="item.chinese"
                    @change="changeShow(show[index], index)"
                  ></el-checkbox>
                </el-dropdown-item>
              </template>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </el-row>
      <el-row class="mt-20">
        <!-- 动态表格组件 -->
        <TableCommon
          v-loading="tabLoading"
          :element-loading-text="$t('elTable.loadingText')"
          element-loading-spinner="el-icon-loading"
          :tableColumns="tableColumns"
          :tableData="tableData"
          :uniqueNum="uniqueNum"
          :height="$store.state.screenHeight - 285"
          :showBtn="'未审核'"
          :btnDefault="$t('sqsq.Reviewed')"
          :cellStyle="$store.state.cellStyle"
          :headerCellStyle="$store.state.headerCellStyle"
          @handleClickFun="handleClickFun"
        ></TableCommon>
      </el-row>
    </el-row>
    <DialogBox
      :dialogVisible="dialogVisible"
      @confirm="confirm"
      @cancel="cancel"
      :title="$t('sqsq.examine')"
      class=""
      :cancelText="$t('common.cancelBtn')"
      :confirmText="$t('common.confirmBtn')"
    >
      <template slot="content">
        <el-row class="">
          <div ref="title" class="title px-20">
            <div class="" style="font-size: 25px;">
              {{$t('sqsq.Applynews')}}
            </div>
            <p class="dy-flex">
              <span class="fw-bold fs-15">{{$t('sqsq.department')}}：</span>
              <span class="fs-15">{{ fromData.department }}</span>
            </p>
            <p class="dy-flex">
              <span class="fw-bold fs-15">{{$t('sqsq.system')}}：</span>
              <span class="fs-15">{{ fromData.sysName }}</span>
            </p>
            <p class="dy-flex">
              <span class="fw-bold fs-15">{{$t('sqsq.project')}}：</span>
              <span class="fs-15">{{ fromData.project }}</span>
            </p>
            <el-row class="py-5">
              <el-col :span="12">
                <span class="fw-bold fs-15">{{$t('sqsq.Applytime')}}：</span>
                <span class="fs-15">{{ setrq(fromData.by1) }}</span>
              </el-col>
              <el-col :span="12" class="dy-flex">
                <span class="fw-bold fs-15">{{$t('sqsq.applicant')}}：</span>
                <span class="fs-15">{{ fromData.sqry }}</span>
              </el-col>
            </el-row>
            <p class="fw-bold fs-15 mt-10">
              {{$t('sqsq.xmsq')}}
            </p>
          </div>
          <el-card>
            <el-form ref="form" :model="form" :label-width="$i18n.locale=='zh'?'80px':'140px'">
              <div class="">
                <el-form-item :label="$t('common.qztime')" class="mb-10 fw-bold fs-15">
                  <el-date-picker
                    v-model="form.qzsj"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    :range-separator="$t('sqsq.to')"
                    :start-placeholder="$t('sqsq.qsrq')"
                    :end-placeholder="$t('sqsq.jzrq')"
                    align="right"
                    size="small"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item
                  :label="$t('sqsq.sqje')"
                  class="mb-10 fw-bold fs-15"
                  v-if="fromData.sysName != '网上查询'&&fromData.sysName != '借开发票'"
                >
                  <el-input
                    size="small"
                    v-model="form.by7"
                    onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')"
                    style="width:145px"
                  ></el-input>
                </el-form-item>
                <el-row>
                  <el-col :span="12">
                    <el-form-item :label="$t('sqsq.ecsq')" class="mb-10 fw-bold fs-15">
                      <el-select v-model="form.by5" clearable size="small">
                        <el-option
                          v-for="item in ecsqOptions"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12" v-if="fromData.sysName == '网上报销'">
                    <el-form-item :label="$t('sqsq.yeck')" class="mb-10 fw-bold fs-15">
                      <el-select v-model="form.by12" clearable size="small">
                        <el-option
                          v-for="item in yeckOptions"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>
              <el-form-item :label="$t('sqsq.Reviewcomments')" class="mb-10 fw-bold fs-15">
                <el-radio-group v-model="form.sqzt">
                  <el-radio :label="0">{{$t('sqsq.adopt')}}</el-radio>
                  <el-radio :label="1">{{$t('sqsq.reject')}}</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item
                :label="$t('sqsq.Reasonrejection')"
                class="mb-10 fw-bold fs-15"
                v-if="form.sqzt == 1"
              >
                <el-input
                  type="textarea"
                  autosize
                  v-model="form.bhyy"
                ></el-input>
              </el-form-item>
            </el-form>
          </el-card>
        </el-row>
      </template>
    </DialogBox>
  </div>
</template>

<script>
import * as sqgl from "@/api/sqgl";
import DialogBox from "@/components/DialogBox.vue";

export default {
  // 审核管理
  name: "projectAuzApprovalView",
  components: { DialogBox },
  computed: {},
  data() {
    return {
      btncolor: 3,
      tabLoading: true,
      tableColumns: [],
      tableData: [],
      uniqueNum: "Y120109-1-1", // 页面唯一标识（用于区分同一页面多个模块多个分组情况）
      yhxx: this.$store.state.yhxx.yhxx,
      show: [],
      argumentDetail: {},
      argumentConfig: {
        xszdTil: {
          moduleId: "1",
          groupId: "1",
          fieldId: "btn-szxszd",
        },
      },
      xszdBtn: {},
      allData: [],
      oneData: [],
      twoData: [],
      zeroData: [],
      fromData: {},
      form: {
        qzsj: [],
        sqje: "",
        by5: "",
        by12: "",
        sqzt: 0,
        by7: "",
      },
      ecsqOptions: [
        {
          value: "0",
          label: this.$t('sqsq.allow'),
        },
        {
          value: "1",
          label: this.$t('sqsq.notallow'),
        },
      ],
      yeckOptions: [
        {
          value: "0",
          label: this.$t('sqsq.shi'),
        },
        {
          value: "1",
          label: this.$t('sqsq.fou'),
        },
      ],
      dialogVisible: false,
      sqtype: 3,
    };
  },
  methods: {
    //   获取当前用户申请的项目
    getXmsqSq() {
      this.tabLoading = true;
      this.zeroData=[];
      this.oneData=[];
      this.twoData=[];
      this.allData=[];
      sqgl.getXmsqSq().then((res) => {
        let data = [];
        data = res.data.data;
        data.forEach((item) => {
          switch (item.sqzt) {
            case "通过":
              this.zeroData.push(item);
              break;
            case "驳回":
              this.oneData.push(item);
              break;
            case "待审核":
              this.twoData.push(item);
              break;
          }
          switch (item.xsyeck) {
            case "0":
              item.yeck = "是";
              item.xsyeck = "是";
              item.by12 = "0";
              break;
            case "1":
              item.yeck = "否";
              item.xsyeck = "否";
              item.by12 = "1";
              break;
          }
        });
        this.allData = data;
        this.filterSqzt(this.sqtype);
        this.tabLoading = false;
      });
    },

    /** 获取页面表格配置信息 */
    getPageTableConfig() {
      let params = {};
      params.pageId = "Y120109";
      params.moduleId = "1";
      params.groupId = "1";
      // 清空表格列配置
      this.tableColumns = []; // 表格列
      // 异步回调
      this.$requestUtil.getXtTableConfig(params).then((tmpResult) => {
        this.tableColumns = tmpResult;
        this.setShow(tmpResult);
      });
    },

    // 获取查询条件信息
    loadQueryConfig() {
      let _this = this;
      let queryInfo = {
        pageId: "Y120109",
      };
      _this.$requestUtil.getXtQueryConfigMy(queryInfo).then((res) => {
        _this.argumentDetail = res;
        this.xszdBtn = this.getArgumentDetail("xszdTil");
      });
    },
    /** 获取参数详情 */
    getArgumentDetail(key) {
      return this.$requestUtil.getArgumentDetail(
        this.argumentConfig,
        this.argumentDetail,
        key
      );
    },
    // 点击按钮或链接
    handleClickFun(row) {
      this.form = {
        qzsj: [],
        sqje: "",
        by5: "",
        by12: "",
        sqzt: 0,
        by7: "",
      };
      this.fromData = {};
      let r = row.row;
      if (row.oprationflg.en == "audit") {
        this.dialogVisible = true;
      }
      this.form.sqzt = 0;
      this.fromData = r;
      this.form.qzsj = [r.qssj, r.jzsj];
      this.form.sqje = r.sqje;
      this.form.by5 = r.sqecsq;
      this.form.by12 = r.by12;
      this.form.by7 = r.sqje;
      this.form.sqid = r.sqid;
      this.form.bmbh = r.bmbh;
      this.form.xmbh = r.xmbh;
      this.form.sysid = r.sysid;
      this.form.xmmc = r.xmmc;
      this.form.sysName = r.sysName;
      this.form.sqrybh = r.sqrybh;
      this.form.sqxtid = r.sqxtid;
      this.form.sqrymc = r.sqrymc;
      this.form.bmmc = r.bmmc;
    },

    // 确认
    confirm() {
      this.form.by3 = this.form.qzsj[0];
      this.form.by4 = this.form.qzsj[1];
      // this.form.by7 = this.form.by7;
      // this.form.by12 = this.form.xsyeck;
      let is = true;
      if (this.form.sqzt == 1) {
        if (this.form.bhyy == undefined || this.form.bhyy == null) {
          this.$message.error(this.$t("sqsq.bhyybnwk"));
          is = false;
        }
      }
      if (is) {
        sqgl.approvalApply(this.form).then((res) => {
          this.dialogVisible = false;
          this.getXmsqSq();
          this.$message.success(res.data.message);
        });
      }
    },
    // 取消
    cancel() {
      this.dialogVisible = false;
    },

    changeShow(val, index) {
      if (val) {
        this.tableColumns[index].isShow = "1";
      } else {
        this.tableColumns[index].isShow = "0";
      }
    },
    setShow(tableColumns) {
      let columns = [];
      columns = tableColumns;
      columns.forEach((item) => {
        // if (item.columnKey != "xzk") {
        if (item.isShow == "1") {
          this.show.push(true);
        } else {
          this.show.push(false);
        }
        // }
      });
    },
    filterSqzt(val) {
      this.sqtype = val;
      this.btncolor = val;
      switch (val) {
        case 0:
          this.tableData = this.zeroData;
          break;
        case 1:
          this.tableData = this.oneData;
          break;
        case 2:
          this.tableData = this.twoData;
          break;
        case 3:
          this.tableData = this.allData;
          break;
      }
    },
    setrq(sj) {
      if (sj) {
        let str = sj;
        let arr = [];
        arr = str.split(" ");
        return arr[0];
      }
      return sj;
    },
  },
  mounted() {
    this.getXmsqSq();
    this.getPageTableConfig();
    this.loadQueryConfig();
  },
};
</script>

<style lang="scss" scoped>
.btnColor {
  background-color: rgb(64, 158, 255);
  color: white;
}
.card {
  padding: 20px 20px 0px 20px;
  border: 1px solid rgba(49, 176, 213, 0.5);
  border-radius: 10px;
  background-color: rgba(49, 176, 213, 0.1);
  // box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
}
.title {
  p {
    padding: 5px 0px;
  }
}
.xmsq {
  border: solid 1px #8dd3e8;
  border-radius: 4px;
  padding-right: 20px;
}
.el-form {
  .el-form-item {
    .el-form-item__label {
      font-weight: bold;
      font-size: 16px;
    }
  }
}
</style>
